import { createAction } from '@ngrx/store';

export const loadAccountUsersStart = createAction('[Account Users] Load Start');
